import { connect } from 'react-redux';

import { addReview, updateReview, handleReviewChange } from 'actions/reviews';
import Review from 'components/common/Review';
import * as Types from 'utilities/types';

const ReviewContainer = ({
  customOutlineColor,
  mealId,
  mealTitle,
  menuId,
  onAddReview,
  onReviewChange,
  onUpdateReview,
  ratingSubmittedEvent,
  review,
  setIsModalOpen,
  setSelectedRating,
  starClassNames,
  starSvgClassName,
}) => {
  const handleReviewClick = rating => {
    if (rating !== undefined) {
      setSelectedRating(rating);
    } else if (review?.pendingChanges?.recipeRating) {
      setSelectedRating(review.pendingChanges.recipeRating);
    } else if (review?.recipeRating) {
      setSelectedRating(review.recipeRating);
    } else {
      setSelectedRating(null);
    }
    setIsModalOpen(true);
  };

  return (
    <div className="flex items-center">
      <div
        onClick={e => {
          e.stopPropagation();
          handleReviewClick(review?.recipeRating);
        }}
        className="cursor-pointer"
      >
        <Review
          uniqueId={mealId}
          id={review?.id}
          onAddReview={params => onAddReview({ ...params, mealId, menuId })}
          onUpdateReview={params => onUpdateReview(review?.id, { ...params, mealId, menuId })}
          onReviewChange={params => {
            onReviewChange(mealId, params);
            if (params.recipeRating !== undefined) {
              setSelectedRating(params.recipeRating);
              setIsModalOpen(true);
            }
          }}
          recipeRating={review?.recipeRating}
          pendingChanges={review?.pendingChanges}
          customOutlineColor={customOutlineColor}
          starClassNames={starClassNames}
          starSvgClassName={starSvgClassName}
          mealTitle={mealTitle}
          ratingSubmittedEvent={ratingSubmittedEvent}
        />
      </div>
      {review?.recipeRating && (
        <p className="textMd ml-2 hidden text-charcoal-90 bp1:block">{review.recipeRating}/5</p>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  onAddReview: addReview,
  onReviewChange: handleReviewChange,
  onUpdateReview: updateReview,
};

ReviewContainer.propTypes = {
  customOutlineColor: PropTypes.string,
  mealTitle: PropTypes.string.isRequired,
  mealId: PropTypes.string.isRequired,
  menuId: PropTypes.string.isRequired,
  onAddReview: PropTypes.func.isRequired,
  onReviewChange: PropTypes.func.isRequired,
  onUpdateReview: PropTypes.func.isRequired,
  ratingSubmittedEvent: PropTypes.string,
  review: Types.review,
  setIsModalOpen: PropTypes.func.isRequired,
  setSelectedRating: PropTypes.func.isRequired,
  starClassNames: PropTypes.string,
  starSvgClassName: PropTypes.string,
};

export default connect(null, mapDispatchToProps)(ReviewContainer);
